import { RepositoryFactory } from '@/api/RepositoryFactory'
import {
  SET_EXPORTERS,
  SET_LOADING,
  SET_ORGANIZATIONS,
  UPDATE_EXPORTER,
} from './actions/organizations'

const Organizations = RepositoryFactory.get('organizations')

export default {
  namespaced: true,
  state: {
    organizations: [],
    exporters: [],
    loading: false,
  },
  getters: {
    isOrgs: state => state.organizations.length,
    getOrganizations: state => state.organizations,
    getOrgById: state => id =>
      state.organizations.find(o => o.id === id)?.short_name || '',
    getExporters: state => state.exporters,
    getExpShortNameById: state => id =>
      state.exporters.find(e => e.id === id)?.short_name || '',
    getLoading: state => state.loading,
  },
  actions: {
    fetchOrganizations({ commit }, settings) {
      commit(SET_LOADING, true)
      Organizations.getOrganizations(settings)
        .then(res => commit(SET_ORGANIZATIONS, res.data))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, false))
    },
    fetchExporters({ commit }) {
      commit(SET_LOADING, true)
      Organizations.getExporters()
        .then(res => commit(SET_EXPORTERS, res.data))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, false))
    },
    updateExporter({ commit }, { id, data }) {
      commit(SET_LOADING, true)
      Organizations.updateItem(id, data)
        .then(res => commit(UPDATE_EXPORTER, res.data))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, false))
    },
  },
  mutations: {
    [SET_LOADING](state, flag) {
      state['loading'] = Boolean(flag)
    },
    [SET_ORGANIZATIONS](state, data) {
      state.organizations = data.items
    },
    [SET_EXPORTERS](state, data) {
      state.exporters = data
    },
    [UPDATE_EXPORTER](state, data) {
      if (data) {
        const index = state.exporters.findIndex(f => f.id === data.id)

        if (index >= 0) {
          state.exporters.splice(index, 1, data)
        }
      }
    },
  },
}
